import { Avatar, Button, Comment, Divider, Dropdown, Input, List, Menu, Modal } from 'antd';
import { DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import {
  commentIsNotBlank,
  deleteComment,
  getComments,
  patchComment,
  postComment,
} from '../../utils/util';
import React, { useEffect, useState } from 'react';

const { TextArea } = Input;

const ReviewComments = props => {
  const { mappingReviewId, checklistType } = props;
  const [comments, setComments] = useState(null);
  const [commentBoxValue, setCommentBoxValue] = useState('');
  const [commentId, setCommentId] = useState('');
  const [editedComment, setEditedComment] = useState('');
  const [showEditModal, setEditModal] = useState(false);
  const [showDelModal, setDelModal] = useState(false);
  const [currComment, setCurrComment] = useState({ id: null, comment: null });

  const getReviewComments = async () => {
    const reviewComments = await getComments(mappingReviewId, checklistType);
    setComments(reviewComments);
  };

  const toggleDelModal = () => {
    setDelModal(!showDelModal);
    return null;
  };

  const handleSubmitReviewComment = async () => {
    // ensures comment is not blank
    if (commentIsNotBlank(commentBoxValue)) {
      const success = await postComment(mappingReviewId, checklistType, commentBoxValue);

      if (success) {
        getReviewComments();
        setCommentBoxValue('');
      }
    }
  };

  const handleUpdateReviewComment = async () => {
    const success = await patchComment(mappingReviewId, checklistType, editedComment, commentId);

    if (success) {
      getReviewComments();
      setCommentBoxValue('');
    }
  };

  const handleDeleteReviewComment = async () => {
    const success = await deleteComment(currComment.id);

    if (success) {
      getReviewComments();
      toggleDelModal();
    }
  };

  const handleCommentBoxChange = ({ target }) => {
    const { value } = target;
    setCommentBoxValue(value);
  };

  const handleEditedCommentBoxChange = ({ target }) => {
    const { value } = target;
    setEditedComment(value);
  };

  useEffect(() => {
    if (props.mappingReviewId) {
      (async () => {
        await getReviewComments();
      })();
    }
  }, [checklistType, currComment]);

  const editReviewComment = async () => {
    // ensures comment is not blank
    if (commentIsNotBlank(editedComment)) {
      await handleUpdateReviewComment();
      await getReviewComments();
    }

    setEditModal(false);
    setCommentId('');
  };

  return (
    <>
      <Modal
        title="Delete Review Comment"
        maskClosable
        visible={showDelModal}
        footer={null}
        onCancel={toggleDelModal}
      >
        <p>Are you sure you want to delete the following comment:</p>
        <p>{currComment.comment}</p>
        <br />
        <Button
          type="danger"
          htmlType="submit"
          onClick={e => [e.stopPropagation(), handleDeleteReviewComment()]}
          data-cy="delete-comment-btn"
        >
          Delete
        </Button>
      </Modal>
      <Divider orientation="center">
        {' '}
        <h3>Comments</h3>
      </Divider>
      <div>
        <TextArea
          onChange={handleCommentBoxChange}
          value={commentBoxValue}
          rows={2}
          placeholder="Type Comment Here"
          data-cy="review-comment"
          maxLength={255}
        />
        <br />
        <br />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button data-cy="submit-review-comment" onClick={handleSubmitReviewComment}>
            Submit Comment
          </Button>
        </div>
      </div>
      {comments && comments.length === 0 && <p>No Comments Yet</p>}
      {comments && comments.length > 0 && (
        <List
          itemLayout="horizontal"
          dataSource={comments}
          header={`${comments.length} ${comments.length > 1 ? 'Comments' : 'Comment'}`}
          renderItem={c => (
            <List.Item>
              {c.id !== commentId && (
                <>
                  <Comment
                    avatar={<Avatar style={{ backgroundColor: '#ca77f7' }}>{c.name[0]}</Avatar>}
                    author={c.name}
                    content={c.comment}
                    datetime={new Date(c.updated_at).toLocaleString()}
                    style={{ whiteSpace: 'pre-wrap' }}
                  />
                  <Dropdown.Button
                    trigger={['click']}
                    disabled={c.user_id !== window.localStorage.getItem('user_id')}
                    data-cy={`open-comment-${c.user_id}`}
                    placement="bottomRight"
                    overlayStyle={{
                      border: '1px solid #d9d9d9',
                      borderRadius: 2,
                    }}
                    icon={<DownOutlined id={`dropdownExtension${c.id}`} />}
                    overlay={
                      <Menu>
                        <Menu.Item
                          key="1"
                          data-cy="edit-comment"
                          id={`edit${c.id}`}
                          onClick={() => [
                            setEditedComment(c.comment),
                            setCommentId(c.id),
                            setEditModal(true),
                          ]}
                          icon={<EditOutlined />}
                          type="primary"
                        >
                          Edit
                        </Menu.Item>
                        <Menu.Item
                          key="2"
                          data-cy="delete-comment"
                          id={`delete${c.id}`}
                          onClick={() => [toggleDelModal(), setCurrComment(c)]}
                          icon={<DeleteOutlined />}
                          type="primary"
                        >
                          Delete
                        </Menu.Item>
                      </Menu>
                    }
                  />
                </>
              )}
              {showEditModal && c.id === commentId && (
                <div style={{ width: '90%', justifyContent: 'center' }}>
                  <TextArea
                    onChange={handleEditedCommentBoxChange}
                    value={editedComment}
                    rows={2}
                    placeholder="Type Comment Here"
                    maxLength={255}
                    data-cy="review-comment-edit"
                  />
                  <div style={{ marginTop: '15px' }}>
                    <Button onClick={editReviewComment}>Edit Comment</Button>
                  </div>
                </div>
              )}
            </List.Item>
          )}
        />
      )}
    </>
  );
};

export default ReviewComments;
